import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "gatsby";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  width: 100%;
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  color: ${({ theme }) => theme.colors.black};
  font-weight: normal;
`;
const CenteredWrapper = styled(Wrapper)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
const Title = styled.h2`
  font-family: ${({ theme }) => theme.fontHeadings.fontFamily};
  color: ${({ theme, textColor }) => textColor || theme.colors.black};
  margin: 0 0 5px 0;
  line-height: 1.3;
  font-weight: 100;
  font-size: 3rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2rem;
  }
`;
const StyledLink = styled(({ textColor: textColorIgnored, ...props }) => (
  <Link {...props} />
))`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-decoration: none;
  font-family: ${({ theme }) => theme.fontLinks.fontFamily};
  color: ${({ textColor, theme }) => textColor || theme.colors.black};
  width: -webkit-fill-available;
  @media all and (-ms-high-contrast: none) {
    width: 150px;
  }
`;
const ChildWrapper = styled(({ textColor: textColorIgnored, ...props }) => (
  <div {...props} />
))`
  color: ${({ textColor, theme }) => textColor || theme.colors.black};
  max-width: 65%;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    max-width: 85%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 100%;
  }
`;

export default function SectionTitle({
  children,
  position,
  title,
  linkUrl,
  linkLabel,
  textColor,
}) {
  if (position === "centered") {
    return (
      <CenteredWrapper>
        <Title
          dangerouslySetInnerHTML={{ __html: title }}
          textColor={textColor}
        />
        {children && (
          <ChildWrapper textColor={textColor}>{children}</ChildWrapper>
        )}
      </CenteredWrapper>
    );
  } else {
    return (
      <Wrapper>
        <InnerWrapper>
          <Title
            dangerouslySetInnerHTML={{ __html: title }}
            textColor={textColor}
          />
          {linkUrl && linkLabel && (
            <StyledLink textColor={textColor} to={linkUrl}>
              {linkLabel}
            </StyledLink>
          )}
        </InnerWrapper>
        {children && (
          <ChildWrapper textColor={textColor}>{children}</ChildWrapper>
        )}
      </Wrapper>
    );
  }
}

SectionTitle.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(["left", "centered"]),
  title: PropTypes.string.isRequired,
  linkUrl: PropTypes.string,
  linkLabel: PropTypes.string,
  textColor: PropTypes.string,
};

SectionTitle.defaultProps = {
  children: undefined,
  position: "left",
  linkUrl: undefined,
  linkLabel: undefined,
  textColor: "#2F2F2F",
};
